import { render, staticRenderFns } from "./BotaoCancelar.vue?vue&type=template&id=553cb3dc"
import script from "./BotaoCancelar.vue?vue&type=script&lang=js"
export * from "./BotaoCancelar.vue?vue&type=script&lang=js"
import style0 from "./BotaoCancelar.vue?vue&type=style&index=0&id=553cb3dc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports